<mat-drawer-container class="example-container">
  <mat-drawer opened class="shadow-sm" [style.background-color]="backgroudColor" [style.color]="color"
    [opened]="isDrawerOpen" #drawer [mode]="dynamicMode">
    <div class="logo">
      <a routerLink="/" class="d-flex h-100 align-items-center logo-img">
        <img class="px-2 mt-3" [style.filter]="filter" [src]="logoUrl" alt="logo" />
      </a>

      <div class="side-menu pt-4">
        <div class="sidemenu-wrapper">
          <div class="accordion">
            <div class="items"
              *ngIf="tenant == 'sl' || tenant == 'qc' || tenant == 'pl' || tenant == 'wylo' || tenant == 'ml' || tenant == 'ml_qc'">
              <div class="main-menu">
                <a [routerLink]="RouteConstants.Dashbaord.Route" routerLinkActive="active" (click)="closeDrawer()"
                  class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center" [style.color]="color">
                    <span class="material-icons">dashboard</span>
                    Dashboard
                  </div>
                </a>
              </div>
            </div>

            <!-- Requested orders column -->
            <div id="accordion" class="accordion custom-sidebar-accordion">
              <div class="accordion-item mb-0">
                <h2 class="accordion-header" *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc' || tenant == 'wylo'  || tenant == 'ml' || tenant == 'ml_qc'">
                  <div class="custom-sidebar-accordion-inner collapsed" data-bs-toggle="collapse"
                    data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix"
                    [style.color]="color">
                    <span class="material-icons">shopping_cart</span>
                    Orders
                  </div>
                </h2>
                <div id="collapseSix" class="accordion-collapse collapse" data-bs-parent="#accordion">
                  <div class="accordion-body py-0 pe-0">
                    <div class="items" *ngIf="tenant == 'pl' || tenant == 'sl'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.RequestedOrder.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">swap_horiz_sharp_icon</span>
                            Requested Orders
                          </div>
                        </a>
                      </div>
                    </div>

                    <div class="items"
                      *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc' || tenant == 'wylo'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <form [formGroup]="formService.saleOrderForm">
                        <div class="main-menu">
                          <a [routerLink]="RouteConstants.SalesOrder.SalesOrder.Route"
                            [queryParams]="this.helperService.salseOrderQueryParams(RouteConstants.SalesOrder.SalesOrder.QueryParams)"
                            [class.active]="isLinkActive(RouteConstants.SalesOrder.SalesOrder.Route)"
                            (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center" [style.color]="color">
                              <span class="material-icons">
                                shopping_cart_checkout
                              </span>
                              Sales Order
                            </div>
                          </a>
                          <div [hidden]="!isLinkActive(RouteConstants.SalesOrder.SalesOrder.Route)">
                            <div class="filters mb-2" *ngIf="formService.getSalesOrderFormStatusArr.value.length > 0"
                              [ngClass]="{'filter-color': tenant === 'sl' || tenant === 'qc'}">
                              <mat-checkbox class="example-margin" color="primary"
                                [checked]="formService.isAllOrderStatusSelected"
                                [indeterminate]="formService.someOrderStatusSelected()"
                                (change)="formService.setAllOrderStatusSelected($event.checked)">
                                <p [style.color]="color">{{ formService.saleOrderForm.value.type }} ({{
                                  formService.allSalesOrdersLength }})</p>
                              </mat-checkbox>
                              <ng-container formArrayName="salesOrderStatus">
                                <ng-container
                                  *ngFor="let item of formService.getSalesOrderFormStatusArr.controls; let i = index">
                                  <ng-container [formGroupName]="i">
                                    <div *ngIf="OrderStatus.All != item.value.type">
                                      <mat-checkbox class="example-margin" color="primary" formControlName="isChecked">
                                        <p [style.color]="color"> {{ item.value.type }} ({{ item.value.sale_orders_count
                                          }})</p>
                                      </mat-checkbox>
                                    </div>
                                  </ng-container>
                                </ng-container>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>

                    <div class="items"
                      *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc' || tenant == 'wylo'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <form [formGroup]="formService.processedOrderForm">
                        <div class="main-menu">
                          <a [routerLink]="RouteConstants.ProcessedOrder.ProcessedOrder.Route"
                            [queryParams]="this.helperService.salseOrderQueryParams(RouteConstants.ProcessedOrder.ProcessedOrder.QueryParams)"
                            [class.active]="isLinkActive(RouteConstants.ProcessedOrder.ProcessedOrder.Route)"
                            (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center" [style.color]="color">
                              <span class="material-icons">done_all</span>
                              Processed Order
                            </div>
                          </a>
                          <div [hidden]="!isLinkActive(RouteConstants.ProcessedOrder.ProcessedOrder.Route)">
                            <div class="filters mb-2"
                              *ngIf="formService.getProcessedOrderFormStatusArr.value.length > 0"
                              [ngClass]="{'filter-color': tenant === 'sl' || tenant ==='qc'}">
                              <mat-checkbox class="example-margin" color="primary"
                                [checked]="formService.isAllProcessedOrderStatusSelected"
                                [indeterminate]="formService.someProcessedOrderStatusSelected()"
                                (change)="formService.setAllProcessedOrderStatusSelected($event.checked)">
                                <p [style.color]="color">{{ formService.processedOrderForm.value.type }} ({{
                                  formService.allProcessedOrdersLength }})</p>
                              </mat-checkbox>
                              <ng-container formArrayName="processedOrderStatus">
                                <ng-container
                                  *ngFor="let item of formService.getProcessedOrderFormStatusArr.controls; let i = index">
                                  <ng-container [formGroupName]="i">
                                    <div *ngIf="OrderStatus.All != item.value.type">
                                      <mat-checkbox class="example-margin" color="primary" formControlName="isChecked">
                                        <p [style.color]="color">{{ item.value.type }} ({{ item.value.sale_orders_count
                                          }})</p>
                                      </mat-checkbox>
                                    </div>
                                  </ng-container>
                                </ng-container>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    <!-- Additional sections can be added here, following the same structure -->
                  </div>
                </div>
              </div>
            </div>

            <!-- End Requested orders column -->

            <div id="accordion" class="accordion custom-sidebar-accordion" *ngIf="tenant == 'wylo'">
              <div class="accordion-item mb-0">
                <h2 class="accordion-header">
                  <div class="custom-sidebar-accordion-inner collapsed" data-bs-toggle="collapse"
                    data-bs-target="#collapseVisit" aria-expanded="false" aria-controls="collapseVisit"
                    [style.color]="color">
                    <span class="material-icons">tour</span>
                    Visits
                  </div>
                </h2>
                <div id="collapseVisit" class="accordion-collapse collapse" data-bs-parent="#accordion">
                  <div class="accordion-body py-0 pe-0">
                    <div class="items" *ngIf="tenant == 'wylo'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Visits.VistList.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">tour</span>
                            Visit List
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="items" *ngIf="tenant == 'wylo'">
              <div class="main-menu">
                <a [routerLink]="RouteConstants.DraftOrder.Route"
                  [queryParams]="this.helperService.salseOrderQueryParams(RouteConstants.DraftOrder.QueryParams)"
                  [class.active]="isLinkActive(RouteConstants.DraftOrder.Route)" (click)="closeDrawer()"
                  class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center" [style.color]="color">
                    <span class="material-icons">cached</span>
                    Upcoming Refill
                  </div>
                </a>
              </div>
            </div>



            <div class="items"
              *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc'  || tenant == 'ml' || tenant == 'ml_qc'">
              <div class="main-menu">
                <a routerLink="/portal/shipping-inventory" routerLinkActive="active" (click)="closeDrawer()"
                  class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center" [style.color]="color">
                    <span class="material-icons">inventory</span>
                    Shipping Inventory
                  </div>
                </a>
              </div>
            </div>

            <div id="accordion" class="accordion custom-sidebar-accordion">
              <div class="accordion-item mb-0">
                <h2 class="accordion-header">
                  <div class="custom-sidebar-accordion-inner collapsed" data-bs-toggle="collapse"
                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour"
                    [style.color]="color">
                    <span class="material-icons">group</span>
                    Users
                  </div>
                </h2>
                <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordion">
                  <div class="accordion-body py-0 pe-0">
                    <div class="items"
                      *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc' || tenant == 'wylo'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Users.UsersList.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">group</span>
                            User List
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items"
                      *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Users.BroadcastingMessage.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons pe-1">mail</span>
                            Broadcast message
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items" *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc' ">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Users.DeletionRequest.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons pe-1 deletionReqIcon">delete_forever_icon</span>
                            Deletion Request
                          </div>
                        </a>
                      </div>
                    </div>

                    <div class="items" *ngIf="tenant == 'sl' || tenant == 'qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.ShellUsers.UsersList.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons pe-1 deletionReqIcon">delete_forever_icon</span>
                            Shell Users
                          </div>
                        </a>
                      </div>
                    </div>

                    <!-- Additional sections can be added here, following the same structure -->
                  </div>
                </div>
              </div>
            </div>

            <div id="accordion" class="accordion custom-sidebar-accordion" style="display: none;"
              *ngIf="tenant == 'pl'  || tenant == 'ml' || tenant == 'ml_qc'">
              <div class="accordion-item mb-0">
                <h2 class="accordion-header">
                  <div class="custom-sidebar-accordion-inner collapsed" data-bs-toggle="collapse"
                    data-bs-target="#collapseFour1" aria-expanded="false" aria-controls="collapseFour1"
                    [style.color]="color">
                    <span class="material-icons">group</span>
                    Staff
                  </div>
                </h2>
                <div id="collapseFour1" class="accordion-collapse collapse" data-bs-parent="#accordion">
                  <div class="accordion-body py-0 pe-0">
                    <div class="items">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Staff.StaffList.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">group</span>
                            Staff List
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="accordion" class="accordion custom-sidebar-accordion" *ngIf="tenant == 'sl'">
              <div class="accordion-item mb-0">
                <h2 class="accordion-header">
                  <div class="custom-sidebar-accordion-inner collapsed" data-bs-toggle="collapse"
                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree"
                    [style.color]="color">
                    <span class="material-icons">medical_services</span>
                    Health & Consultation
                  </div>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordion">
                  <div class="accordion-body py-0 pe-0">
                    <div class="items" *ngIf="tenant == 'sl'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.PreAssessment.PreAssessmentList.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">settings_ethernet</span>
                            Pharmacist Consultation
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items" *ngIf="tenant == 'sl'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.HealthProgramRoute.HealthProgramList.Route"
                          routerLinkActive="active" (click)="closeDrawer()"
                          class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">settings_ethernet</span>
                            Health Care Programs
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items" *ngIf="tenant == 'sl'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.HealthCarePlanRoute.HealthCarePlanList.Route"
                          routerLinkActive="active" (click)="closeDrawer()"
                          class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">settings_ethernet</span>
                            Health Care Plan
                          </div>
                        </a>
                      </div>
                    </div>
                    <!-- <div class="items" *ngIf="tenant == 'sl'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.TakeHomeSummary.TakeHomeSummaryList.Route"
                          routerLinkActive="active" (click)="closeDrawer()"
                          class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">settings_ethernet</span>
                            Take Home Summary
                          </div>
                        </a>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="items"
              *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc'  || tenant == 'ml' || tenant == 'ml_qc'">
              <div class="main-menu">
                <a [routerLink]="RouteConstants.RenewRefill.UsersList.Route" routerLinkActive="active"
                  (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center" [style.color]="color">
                    <span class="material-icons">cached</span>
                    Renewal Refill Request
                  </div>
                </a>
              </div>
            </div>

            <!-- see a doctor start -->
            <!-- <div
            id="accordionPrescriptions"
            class="accordion custom-sidebar-accordion"
            *ngIf="!hideForslqc">
            <div class="card mb-0">
              <div
                class="card-header collapsed"
                data-toggle="collapse"
                href="#collapseDoctor"
                [style.color]="color"
              >
                <a class="card-title" [style.color]="color" >
                  <span class="material-icons" style="width: 18px;"> person2_icon </span>
                  See A Doctor </a
                >
              </div>
              <div
                id="collapseDoctor"
                class="card-body py-0 pr-0 collapse"
                data-parent="#accordionPrescriptions"
              >
                <div class="items" *ngIf="tenant == 'pl'">
                  <div class="main-menu">
                    <a
                      [routerLink]="
                        RouteConstants.createUserAppointment.AppointmentAdd.Route
                      "
                      routerLinkActive="active"
                      (click)="closeDrawer()"
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div
                        class="d-flex align-items-center"
                        [style.color]="color"
                      >
                        <span class="material-icons pr-1 ml-1"
                          >settings_ethernet
                        </span>
                        Create User Appointment
                      </div>
                    </a>
                  </div>
                </div>

              </div>
            </div>
          </div> -->
            <!-- see a doctor end -->


            <div id="accordionPrescriptions" class="accordion custom-sidebar-accordion"
              *ngIf="tenant == 'sl' || tenant == 'qc' || tenant == 'pl'  || tenant == 'ml' || tenant == 'ml_qc'">
              <div class="accordion-item mb-0">
                <h2 class="accordion-header">
                  <div class="custom-sidebar-accordion-inner collapsed" data-bs-toggle="collapse"
                    data-bs-target="#collapsePrescriptions" aria-expanded="false" aria-controls="collapsePrescriptions"
                    [style.color]="color">
                    <span class="material-icons">medication_liquid</span>
                    Prescriptions
                  </div>
                </h2>
                <div id="collapsePrescriptions" class="accordion-collapse collapse"
                  data-bs-parent="#accordionPrescriptions">
                  <div class="accordion-body py-0 pe-0">
                    <div class="items"
                      *ngIf="tenant == 'sl' || tenant == 'qc' || tenant == 'pl'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Prescriptions.PrescriptionsList.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">settings_ethernet</span>
                            Uploaded and Faxed
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items"
                      *ngIf="tenant == 'sl' || tenant == 'qc' || tenant == 'pl'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.TransferPrescriptions.TransferPrescriptionsList.Route"
                          routerLinkActive="active" (click)="closeDrawer()"
                          class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">settings_ethernet</span>
                            Transfer Prescriptions
                          </div>
                        </a>
                      </div>
                    </div>
                    <!-- <div class="items" *ngIf="tenant == 'sl'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.ShellEprescriptions.PrescriptionsList.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">settings_ethernet</span>
                            Shell ePrescription
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items" *ngIf="tenant == 'sl'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.DialogueEprescription.PrescriptionsList.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">settings_ethernet</span>
                            Prescriptions Awaiting Consent Old
                          </div>
                        </a>
                      </div>
                    </div> -->
                    <div class="items" *ngIf="(tenant == 'sl' || tenant == 'qc')">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.DialogueAndShellEprescription.PrescriptionsList.Route"
                          routerLinkActive="active" (click)="closeDrawer()"
                          class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">settings_ethernet</span>
                            Prescriptions Awaiting Consent
                          </div>
                        </a>
                      </div>
                    </div>

                    <div class="items" *ngIf="tenant == 'pl'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.RingCentralPrescriptionRoute.RingCentralList.Route"
                          routerLinkActive="active" (click)="closeDrawer()"
                          class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">assignment_add</span>
                            Unmatched fax queue - All Tenants
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div id="accordion" class="accordion custom-sidebar-accordion"
              *ngIf="tenant == 'sl' || tenant == 'qc' || tenant == 'pl' || tenant == 'wylo'  || tenant == 'ml' || tenant == 'ml_qc'">
              <div class="accordion-item mb-0">
                <h2 class="accordion-header">
                  <div class="collapsed custom-sidebar-accordion-inner" data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo"
                    [style.color]="color">
                    <span class="material-icons">payments</span>
                    Payments
                  </div>
                </h2>
                <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordion">
                  <div class="accordion-body py-0 pe-0">
                    <div class="items"
                      *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc' || tenant == 'wylo'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.RecentPayments.RecentPaymentsList.Route"
                          routerLinkActive="active" (click)="closeDrawer()"
                          class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">settings_ethernet</span>
                            Recent Payments
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items"
                      *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc' || tenant == 'wylo'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.PendingPayments.PendingPaymentsList.Route"
                          routerLinkActive="active" (click)="closeDrawer()"
                          class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">settings_ethernet</span>
                            Pending Payments
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="items"
              *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc'  || tenant == 'ml' || tenant == 'ml_qc'">
              <div class="main-menu">
                <a [routerLink]="RouteConstants.DrugsRoute.DrugsList.Route" routerLinkActive="active"
                  (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center" [style.color]="color">
                    <span class="material-icons">medication</span>
                    Drugs List
                  </div>
                </a>
              </div>
            </div>

            <div class="items" *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc'">
              <div class="main-menu">
                <a [routerLink]="RouteConstants.TaskManagement.Route" routerLinkActive="active" (click)="closeDrawer()"
                  class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center" [style.color]="color">
                    <span class="material-icons">domain_verification_outlined</span>
                    Task Management
                  </div>
                </a>
              </div>
            </div>


            <div class="items" *ngIf="tenant == 'pl'">
              <div class="main-menu">
                <a [routerLink]="RouteConstants.RxPrescriptionRoute.RxList.Route" routerLinkActive="active"
                  (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center" [style.color]="color">
                    <span class="material-icons">medical_services</span>
                    P-Exchange Prescriptions
                  </div>
                </a>
              </div>
            </div>

            <div class="items" *ngIf="tenant == 'pl' && (emailAllowed == 'amaheshwari@pillway.net' || emailAllowed == 'rnagpal@pillway.com' || emailAllowed == 'hmahil@pillway.com')">
              <div class="main-menu">
                <a [routerLink]="RouteConstants.doctorAppointments.doctorAppointments.Route" routerLinkActive="active"
                  (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center" [style.color]="color">
                    <span class="material-icons">person</span>
                    User Appointments
                  </div>
                </a>
              </div>
            </div>

            <div class="items" hidden>
              <div class="main-menu">
                <a [routerLink]="RouteConstants.Survey.Route" routerLinkActive="active" (click)="closeDrawer()"
                  class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center" [style.color]="color">
                    <span class="material-icons">settings_ethernet</span>
                    Appointment
                  </div>
                </a>
              </div>
            </div>

            <div id="accordion" class="accordion custom-sidebar-accordion"
              *ngIf="tenant == 'sl' || tenant == 'qc' || tenant == 'wylo' || tenant == 'ml' || tenant == 'ml_qc'">
              <div class="accordion-item mb-0">
                <h2 class="accordion-header">
                  <div class="custom-sidebar-accordion-inner collapsed" data-bs-toggle="collapse"
                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive"
                    [style.color]="color">
                    <span class="material-icons">redeem</span>
                    Discount
                  </div>
                </h2>
                <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordion">
                  <div class="accordion-body py-0 pe-0">
                    <div class="items"
                      *ngIf="tenant == 'sl' || tenant == 'qc' || tenant == 'wylo' || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.PromoCode.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">settings_ethernet</span>
                            Promo Code
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items" *ngIf="tenant == 'sl' || tenant == 'qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.AdditionalCoverage.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">settings_ethernet</span>
                            Additional Coverage
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- <div class="items" *ngIf="tenant == 'sl' || tenant == 'qc'">
              <div class="main-menu">
                <a
                  [routerLink]="RouteConstants.DetailReport.Route"
                  routerLinkActive="active"
                  (click)="closeDrawer()"
                  class="d-flex align-items-center justify-content-between"
                >
                  <div class="d-flex align-items-center" [style.color]="color">
                    <span class="material-icons pr-1 ml-1"> summarize </span>
                    Report
                  </div>
                </a>
              </div>
            </div> -->

            <div id="accordion1" class="accordion custom-sidebar-accordion" *ngIf="tenant == 'sl' || tenant == 'qc'">
              <div class="accordion-item mb-0">
                <h2 class="accordion-header">
                  <div class="custom-sidebar-accordion-inner collapsed" data-bs-toggle="collapse"
                    data-bs-target="#collapseFive1" aria-expanded="false" aria-controls="collapseFive1"
                    [style.color]="color">
                    <span class="material-icons">summarize</span>
                    Report
                  </div>
                </h2>
                <div id="collapseFive1" class="accordion-collapse collapse" data-bs-parent="#accordion1">
                  <div class="accordion-body py-0 pe-0">
                    <div class="items" *ngIf="tenant == 'sl' || tenant == 'qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.DetailReport.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">summarize</span>
                            Sunlife Reports
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items" *ngIf="tenant == 'sl' || tenant == 'qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.DiabetesSnapshotReport.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">summarize</span>
                            Diabetes Snapshot
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- <div class="items" *ngIf="tenant == 'sl' || tenant == 'qc'">
              <div class="main-menu">
                <a
                  [routerLink]="RouteConstants.DetailReport.Route"
                  routerLinkActive="active"
                  (click)="closeDrawer()"
                  class="d-flex align-items-center justify-content-between"
                >
                  <div class="d-flex align-items-center" [style.color]="color">
                    <span class="material-icons pr-1 ml-1"> summarize </span>
                    Report
                  </div>
                </a>
              </div>
            </div> -->

            <div id="accordion" class="accordion custom-sidebar-accordion"
              *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc'  || tenant == 'ml' || tenant == 'ml_qc'">
              <div class="accordion-item mb-0">
                <h2 class="accordion-header">
                  <div class="custom-sidebar-accordion-inner collapsed" data-bs-toggle="collapse"
                    data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne"
                    [style.color]="color">
                    <span class="material-icons">settings</span>
                    Settings
                  </div>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordion">
                  <div class="accordion-body py-0 pe-0">
                    <div class="items"
                      *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Settings.MessageTemplateList.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">
                              settings_ethernet
                            </span>
                            Message Template
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items"
                      *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Settings.OnHoldReasonList.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">
                              settings_ethernet
                            </span>
                            <!-- may be remove for titan and pl -->
                            On Hold Reasons
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items"
                      *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Settings.CanceledReasonList.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">
                              settings_ethernet
                            </span>
                            <!-- may be remove for titan and pl -->
                            Cancelled Reasons
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items"
                      *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Settings.TransferReasonList.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">
                              settings_ethernet
                            </span>
                            <!-- may be remove for titan and pl -->
                            Transfer Reason
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items" *ngIf="tenant == 'sl' || 'pl'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="
                          RouteConstants.Settings.UserDeleteReasonList.Route
                        " routerLinkActive="active" (click)="closeDrawer()"
                          class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons pr-1">
                              settings_ethernet
                            </span>
                            User Delete Reasons
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items" *ngIf="!hideForslqc && this.tenant != 'ml' && this.tenant != 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Settings.AppointmentPlatformList.Route"
                          routerLinkActive="active" (click)="closeDrawer()"
                          class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">
                              settings_ethernet
                            </span>
                            <!-- may be remove for titan and pl -->
                            Appointment Platforms
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items"
                      *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Settings.ReferralCodeList.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">
                              settings_ethernet
                            </span>
                            Referral Code
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items" *ngIf="tenant == 'sl' || tenant == 'qc' || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Consent.Route" routerLinkActive="active" (click)="closeDrawer()"
                          class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">
                              settings_ethernet
                            </span>
                            <!-- may be remove for titan and pl -->
                            Consent
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items" *ngIf="tenant == 'sl' || tenant == 'pl'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Settings.DaylightSaving.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">
                              settings_ethernet
                            </span>
                            Daylight Saving
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items" *ngIf="tenant == 'sl' || tenant == 'pl'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Settings.Features.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">
                              settings_ethernet
                            </span>
                            Application Features
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items" *ngIf="tenant == 'sl' || tenant == 'pl'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Settings.PatientGroup.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">
                              settings_ethernet
                            </span>
                            Patient Group
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items" *ngIf="!hideForslqc && this.tenant != 'ml' && this.tenant != 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Settings.PexchangePartners.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">
                              settings_ethernet
                            </span>
                            <!-- may be remove for titan and pl -->
                            Pexchange Partners
                          </div>
                        </a>
                      </div>
                    </div>
                    <div class="items"
                      *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc'  || tenant == 'ml' || tenant == 'ml_qc'">
                      <div class="main-menu">
                        <a [routerLink]="RouteConstants.Settings.BasicSettings.Route" routerLinkActive="active"
                          (click)="closeDrawer()" class="d-flex align-items-center justify-content-between">
                          <div class="d-flex align-items-center" [style.color]="color">
                            <span class="material-icons">
                              settings_ethernet
                            </span>
                            Basic Settings
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <app-header></app-header>
    <div class="main">
      <router-outlet></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
